/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * MODULE: store.js
 * Author: SE EMK
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------- Imports --------------------------------- */
import Vue from 'vue'
import Vuex from 'vuex'

/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
/* --------------------------------- Body ----------------------------------- */
Vue.use(Vuex)

/* -------------------------------- Exports --------------------------------- */
export default new Vuex.Store({
  strict: true
})



// WEBPACK FOOTER //
// ./src/store/store.js